import { Suspense } from "react";
import { MissingBlock } from "./MissingBlock";
import { BLOCK_REGISTRY } from "./registry";

export interface Block {
  block: string;
  [key: string]: unknown;
}

/**
 * Renders an array of blocks from YAML front matter.
 * Looks up each block name in the registry and renders the corresponding component.
 * In dev mode, shows a MissingBlock warning for unimplemented blocks.
 *
 * Registry components are lazy-loaded (see registry.tsx), so each block is
 * wrapped in its own <Suspense> boundary. Under streaming SSR this renders the
 * real block markup into the server HTML; on the client each block's chunk is
 * fetched on demand, so a page ships only the blocks it uses.
 */
export function BlockRenderer({ blocks }: { blocks: Block[] }) {
  if (!blocks || !Array.isArray(blocks)) return null;

  return (
    <>
      {blocks.map((block, i) => {
        if (!block.block) return null;

        const Component = BLOCK_REGISTRY[block.block];
        if (!Component) {
          return <MissingBlock key={i} name={block.block} data={block} />;
        }

        return (
          <Suspense key={i} fallback={null}>
            <Component {...block} />
          </Suspense>
        );
      })}
    </>
  );
}
